<template>
  <teleport to="body">
    <transition name="welcome-fade">
      <div v-if="open" class="welcome-overlay" @click.self="close">
        <div class="welcome-modal" role="dialog" aria-modal="true" aria-labelledby="welcome-title">
        <button class="close-btn" type="button" @click="close" aria-label="Fechar boas-vindas">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>

        <h2 id="welcome-title" class="title-stagger">
          BEM-VINDO À <span class="brand">ZIMA</span>
        </h2>

        <p class="lead">
          <span class="lead-line l1">Você <span class="lead-accent">não assinou</span> uma plataforma.</span>
          <span class="lead-line l2">Você <span class="lead-accent">parou de ser o alvo</span>.</span>
          <span class="lead-line l3 lead-gap">A partir de agora você enxerga <span class="lead-focus">o que move o mercado de verdade</span></span>
          <span class="lead-line l4 contrast-line">- não o que te vendem pra você acreditar.</span>
          <span class="lead-line l5 lead-gap manifesto-line">Sem hype. Sem promessa. Só estrutura.</span>
          <span class="lead-line l6 lead-gap closing-line">Nível desbloqueado, <span class="username-highlight">{{ safeUsername }}</span></span>
        </p>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'WelcomeFirstAccessModal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: '',
    },
  },
  computed: {
    safeUsername() {
      const value = String(this.username || '').trim();
      return value || 'Trader';
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.welcome-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  background:
    radial-gradient(circle at 20% 15%, rgba(78, 115, 223, 0.24), transparent 42%),
    radial-gradient(circle at 80% 75%, rgba(155, 89, 182, 0.22), transparent 44%),
    rgba(7, 9, 15, 0.76);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(7px);
}

.welcome-modal {
  width: min(760px, 100%);
  position: relative;
  border-radius: 22px;
  border: 1px solid rgba(121, 150, 247, 0.42);
  background: linear-gradient(165deg, rgba(18, 25, 43, 0.94), rgba(12, 17, 30, 0.96));
  padding: 28px 28px 24px;
  color: #f5f8ff;
  box-shadow: 0 24px 50px rgba(0, 0, 0, 0.5);
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
  overflow: hidden;
  animation: zima-neon-pulse 4.2s ease-in-out infinite;
  isolation: isolate;
  will-change: transform, opacity;
}

.welcome-modal::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  border: 1px solid transparent;
  background:
    linear-gradient(165deg, rgba(18, 25, 43, 0.94), rgba(12, 17, 30, 0.96)) padding-box,
    linear-gradient(135deg, rgba(111, 166, 255, 0.6), rgba(189, 139, 255, 0.55), rgba(111, 166, 255, 0.45))
      border-box;
  pointer-events: none;
  z-index: 1;
}

.welcome-modal::after {
  content: '';
  position: absolute;
  inset: -20%;
  border-radius: inherit;
  background:
    radial-gradient(circle at 22% 28%, rgba(120, 170, 255, 0.1), transparent 34%),
    radial-gradient(circle at 80% 72%, rgba(188, 137, 255, 0.09), transparent 36%),
    repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.018) 0 1px, rgba(255, 255, 255, 0) 1px 7px),
    repeating-linear-gradient(45deg, rgba(134, 165, 255, 0.015) 0 1px, rgba(134, 165, 255, 0) 1px 9px);
  mix-blend-mode: screen;
  opacity: 0.22;
  filter: saturate(110%);
  pointer-events: none;
  z-index: 1;
  animation: zima-crystal-noise 14s linear infinite;
  will-change: transform, opacity;
}


.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(139, 167, 255, 0.46);
  background:
    linear-gradient(165deg, rgba(18, 25, 43, 0.8), rgba(12, 17, 30, 0.82)) padding-box,
    linear-gradient(135deg, rgba(78, 115, 223, 0.7), rgba(155, 89, 182, 0.68)) border-box;
  -webkit-appearance: none;
  appearance: none;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  z-index: 4;
}

.close-btn i {
  font-size: 0.82rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(176, 197, 255, 0.8);
  box-shadow: 0 10px 24px rgba(8, 13, 28, 0.45);
}

.close-btn:focus-visible {
  outline: 2px solid rgba(143, 181, 255, 0.85);
  outline-offset: 2px;
}

h2 {
  margin: 0;
  font-size: clamp(1.5rem, 3.1vw, 2.3rem);
  line-height: 1.15;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
  position: relative;
  z-index: 2;
}

.brand {
  background: linear-gradient(120deg, #6fa6ff 0%, #bd8bff 45%, #7ea5ff 75%, #d2b2ff 100%);
  background-size: 220% 220%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 14px rgba(127, 166, 255, 0.28);
  animation: zima-brand-shift 4.2s ease-in-out infinite;
  will-change: background-position;
}

.lead {
  margin: 14px 0 2px;
  color: #dbe4ff;
  font-size: clamp(1.02rem, 2.1vw, 1.28rem);
  line-height: 1.62;
  max-width: 58ch;
  font-weight: 500;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
  position: relative;
  z-index: 2;
}

.title-stagger,
.lead-line {
  opacity: 0;
  transform: translateY(10px);
  animation: zima-text-in 0.46s cubic-bezier(0.2, 0.75, 0.2, 1) forwards;
  will-change: transform, opacity;
}

.title-stagger {
  animation-delay: 0.08s;
}

.lead-line {
  display: block;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.lead-accent {
  font-weight: 800;
  color: #dbe6ff;
}

.lead-focus {
  font-weight: 800;
  background: linear-gradient(120deg, #8fc0ff 0%, #c9a8ff 50%, #8fc0ff 100%);
  background-size: 180% 180%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: zima-focus-shift 6s ease-in-out infinite;
}

.manifesto-line {
  letter-spacing: 0.02em;
  font-weight: 700;
}

.contrast-line {
  font-style: italic;
  opacity: 0.96;
}

.closing-line {
  position: relative;
  padding-left: 14px;
}

.closing-line::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.2em;
  width: 2px;
  height: 1.05em;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(143, 187, 255, 0.95), rgba(190, 145, 255, 0.9));
  box-shadow: 0 0 10px rgba(143, 187, 255, 0.35);
}

.username-highlight {
  font-weight: 800;
  color: #eef3ff;
  text-shadow: 0 0 10px rgba(152, 185, 255, 0.3);
}

.lead-line + .lead-line {
  margin-top: 2px;
}

.lead-gap {
  margin-top: 22px !important;
}

.l1 { animation-delay: 0.16s; }
.l2 { animation-delay: 0.24s; }
.l3 { animation-delay: 0.33s; }
.l4 { animation-delay: 0.41s; }
.l5 { animation-delay: 0.5s; }
.l6 { animation-delay: 0.58s; }

.welcome-fade-enter-active,
.welcome-fade-leave-active {
  transition: opacity 0.24s ease;
}

.welcome-fade-enter-from,
.welcome-fade-leave-to {
  opacity: 0;
}

.welcome-fade-enter-active .welcome-modal {
  animation: zima-modal-in 0.34s cubic-bezier(0.2, 0.72, 0.2, 1) both;
}

.welcome-fade-leave-active .welcome-modal {
  animation: zima-modal-out 0.2s ease both;
}

@keyframes zima-neon-pulse {
  0%,
  100% {
    box-shadow:
      0 24px 50px rgba(0, 0, 0, 0.5),
      0 0 0 1px rgba(108, 145, 255, 0.14),
      0 0 14px rgba(78, 115, 223, 0.16);
  }
  50% {
    box-shadow:
      0 24px 52px rgba(0, 0, 0, 0.54),
      0 0 0 1px rgba(143, 173, 255, 0.24),
      0 0 20px rgba(78, 115, 223, 0.24);
  }
}

@keyframes zima-crystal-noise {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 0.2;
  }
  50% {
    transform: translate3d(-1.2%, 0.6%, 0);
    opacity: 0.28;
  }
  100% {
    transform: translate3d(1%, -0.6%, 0);
    opacity: 0.2;
  }
}

@keyframes zima-brand-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes zima-focus-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes zima-text-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes zima-modal-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes zima-modal-out {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(6px) scale(0.99);
  }
}

@media (max-width: 767px) {
  .welcome-modal {
    padding: 20px 16px 16px;
    border-radius: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .title-stagger,
  .lead-line {
    animation: none;
    opacity: 1;
    transform: none;
  }

  .welcome-fade-enter-active .welcome-modal,
  .welcome-fade-leave-active .welcome-modal {
    animation: none;
  }
}
</style>